import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios"; 
import Header from "../components/Layout/Header";
import Footer from "../components/Layout/Footer";
import SubProductDetails from "../components/Product/SubProductDetails.jsx";
import {Loader} from '../components/Layout/Loader';
import { server } from "../server.js";

const SubProductPage = () => {
  const { subProductId } = useParams(); 
  const [subProduct, setSubProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSubProduct = async () => {
      try {
        const { data } = await axios.get(`${server}/subproduct/${subProductId}`);

        setSubProduct(data); 
        setLoading(false);
        setError(null); 
      } catch (error) {
        console.error("Error fetching sub-product", error);
        setError("Error fetching sub-product. Please try again later.");
        setLoading(false);
      }
    };

    fetchSubProduct();
  }, [subProductId]);

  if (loading) {
    return <Loader/> ;
  }

  if (error) {
    return <div>{error}</div>; 
  }

  if (!subProduct) {
    return <div>Суб-продукт не знайдено!</div>;
  }

  return (
    <div>
      <Header />
      <SubProductDetails subProduct={subProduct} />
      <Footer />
    </div>
  );
};

export default SubProductPage;

